"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppContext = void 0;
const react_1 = require("react");
const AppContext_1 = require("../AppContext");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAppContext = () => {
    return react_1.useContext(AppContext_1.AppContext);
};
exports.useAppContext = useAppContext;
//# sourceMappingURL=useAppContext.js.map